import { Link2, Radar, Sparkles } from 'lucide-react'

const steps = [
  {
    step: 1,
    icon: Link2,
    title: 'Add product URL',
    description: 'Start with a store or product page and let the workflow carry context into onboarding and generation.',
  },
  {
    step: 2,
    icon: Radar,
    title: 'Research winning patterns',
    description: 'Use AI research to understand offers, audience signals, and visual motifs before making new assets.',
  },
  {
    step: 3,
    icon: Sparkles,
    title: 'Generate creatives fast',
    description: 'Translate what you learned into image and video concepts that are ready for production and testing.',
  },
]

export function HowItWorksSection() {
  return (
    <section id="how-it-works" className="scroll-mt-28 px-4 py-20 sm:px-6 lg:px-8 lg:pb-24">
      <div className="mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300/85">
            Workflow
          </p>
          <h2 className="mt-4 text-3xl font-bold text-white sm:text-4xl">
            How it works
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-300">
            A simplified path from raw product context to campaign-ready creative direction.
          </p>
        </div>

        <div className="landing-panel relative rounded-[2rem] p-6 sm:p-8 lg:p-10">
          <div className="pointer-events-none absolute left-1/2 top-20 hidden h-px w-[68%] -translate-x-1/2 bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent lg:block" />
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
            {steps.map((item, index) => (
              <div
                key={item.step}
                className="landing-panel relative rounded-[1.75rem] p-6 text-left opacity-0 animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="mb-6 flex items-center gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/[0.06] text-cyan-300 ring-1 ring-white/10">
                    <item.icon className="h-6 w-6" />
                  </div>
                  <div className="flex h-9 w-9 items-center justify-center rounded-full border border-cyan-400/30 bg-cyan-400/10 text-sm font-semibold text-cyan-200">
                    0{item.step}
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-white">{item.title}</h3>
                <p className="mt-3 text-sm leading-7 text-slate-300">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
